export const toolsArr = [
  {
    key: "1",
    label: "批量导入",
  },
  {
    key: "2",
    label: "一键通过",
  },
  {
    key: "3",
    label: "一键驳回",
  },
];

export const fields = [
  {
    dataIndex: "id",
    key: "id",
    title: "用户ID",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "nickName",
    key: "nickName",
    title: "用户名称",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "userName",
    key: "userName",
    title: "账号",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "deptName",
    key: "deptName",
    title: "组织",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "roleName",
    key: "roleName",
    title: "角色",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "status",
    key: "status",
    title: "用户状态",
    width: 180,
    isShow: true,
    scopedSlots: {
      customRender: "UserTag",
    },
  },
  {
    dataIndex: "phonenumber",
    key: "phonenumber",
    title: "手机号码",
    isShow: false,
  },
  {
    dataIndex: "email",
    key: "email",
    title: "邮箱",
    isShow: false,
  },
  {
    isShow: true,
    dataIndex: "createTime",
    key: "createTime",
    title: "创建时间",
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    isShow: true,
    width: 180,
    scopedSlots: {
      customRender: "action",
    },
  },
];
export const slotOpt = [
  {
    slot: "action",
    component: "UserAction",
    //   list: [
    //     { userName: '详情', cb: 'detail' },
    //     { userName: '编辑', cb: 'edit',divider: true },
    //     { userName: '驳回', cb: 'rejected', divider: true },
    //     { userName: '删除', cb: 'singleDelete', divider: true }
    //   ]
  },
  {
    slot: "UserTag",
    component: "UserTag",
    list: [
      {
        userName: "正常",
        color: "blue",
        cb: "normal",
      },
      {
        userName: "禁用",
        color: "purple",
        cb: "banned",
      },
      {
        userName: "待通过",
        color: "orange",
      },
    ],
  },
];
